"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcProjectStartAndEndDates = void 0;
var calcProjectStartAndEndDates = function (startYear, startMonth) {
    var year = parseInt(startYear);
    var month = parseInt(startMonth);
    // Create dates in UTC to avoid timezone issues
    var startDate = new Date(Date.UTC(year, month - 1, 1));
    var endDate = new Date(Date.UTC(year + 1, month - 1, 0)); // Day 0 = last day of previous month
    return { startDate: startDate, endDate: endDate };
};
exports.calcProjectStartAndEndDates = calcProjectStartAndEndDates;
exports.default = exports.calcProjectStartAndEndDates;
